import { Action } from '@ngrx/store';

import { DocumentWithId, DocumentWithRev, DocumentWithType } from '../../models/document-with-type';


export const INSERT = '[DB_SERVICE] INSERT';
export const UPDATE = '[DB_SERVICE] UPDATE';
export const REMOVE = '[DB_SERVICE] REMOVE';
export const BULK_UPDATE = '[DB_SERVICE] BULK_UPDATE';
export const BULK_REMOVE = '[DB_SERVICE] BULK_REMOVE';


export class Insert implements Action {
	readonly type = INSERT;

	constructor(public payload: DocumentWithType) {}
}

export class Update implements Action {
	readonly type = UPDATE;

	constructor(public payload: DocumentWithType & DocumentWithRev) {}
}

export class BulkUpdate implements Action {
	readonly type = BULK_UPDATE;

	constructor(public payload: Array<DocumentWithId & DocumentWithRev>) {}
}

export class Remove implements Action {
	readonly type = REMOVE;

	constructor(public payload: DocumentWithId & DocumentWithRev) {}
}

export class BulkRemove implements Action {
	readonly type = BULK_REMOVE;

	constructor(public payload: Array<DocumentWithId & DocumentWithRev>) {}
}

export type All
	= Insert
	| Update
	| BulkUpdate
	| BulkRemove
	| Remove;



// WEBPACK FOOTER //
// ./src/app/shared/services/db/state-management/actions/db.ts